import { Calendar, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_DISPLAY, PHONE_HREF } from "@/data/business";
import { trackCallClick } from "@/lib/analytics";

/**
 * Persistent mobile action bar. Local searchers on phones convert by calling,
 * so click-to-call leads and gets the visually dominant treatment.
 */
const StickyMobileCTA = () => {
  return (
    <aside
      aria-label="Call or request a consultation"
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-primary border-t border-primary/20 px-3 py-2 safe-area-bottom"
    >
      <div className="flex items-stretch gap-2">
        <a
          href={PHONE_HREF}
          onClick={() => trackCallClick("sticky_mobile_cta")}
          className="flex flex-1 min-h-[44px] items-center justify-center gap-2 rounded-md bg-warm px-3 text-warm-foreground font-semibold text-sm"
        >
          <Phone className="h-4 w-4 shrink-0" aria-hidden />
          <span>Call {PHONE_DISPLAY}</span>
        </a>
        <Link
          to="/contact"
          className="flex min-h-[44px] items-center justify-center gap-2 rounded-md border border-primary-foreground/35 px-3 text-primary-foreground font-medium text-sm"
        >
          <Calendar className="h-4 w-4 shrink-0" aria-hidden />
          <span>Consult</span>
        </Link>
      </div>
    </aside>
  );
};

export default StickyMobileCTA;
